import styled from 'styled-components';
import theme from 'styled-theming';
import { prefix } from '../../../tools/settings';
var Controls = styled.div.withConfig({
  displayName: "Controlsstyles__Controls",
  componentId: "sc-18ctjez-0"
})(["position:absolute;bottom:0;left:var(--dentsu-spacing-80);z-index:2;width:calc(56vw - 160px);height:150px;padding-top:var(--dentsu-spacing-24);padding-bottom:var(--dentsu-spacing-80);border-top:1px solid ", ";.", "-icon-button{margin-right:var(--dentsu-spacing-12);}"], theme('level', {
  one: 'var(--dentsu-color-n600)',
  two: 'var(--dentsu-color-n300)'
}), prefix);
export var Styled = {
  Controls: Controls
};